import React from 'react';
import { ReactComponent as BoletoIcon } from '../assets/copy.svg'
import { ReactComponent as ShareIcon } from '../assets/share.svg'
import { ReactComponent as ShareIconWhite } from '../assets/share_white.svg'
import { ReactComponent as DownloadIcon } from '../assets/download.svg'
import { LoadingSpinner } from './Loading';

type ThemeKey = 'lightgreen' | 'darkgreen' | 'mediumgreen' | 'white' | 'blue';
type IconKey = 'copy' | 'share' | 'share_white' | 'download' | 'none'

interface Props {
  children: string;
  onClick?: () => void;
  theme: ThemeKey;
  icon: IconKey;
  className?: string;
  loading?: boolean;
}

type IconComponent = React.FC<React.SVGProps<SVGSVGElement>>

type ThemeValues = {
  border: string,
  bg: string,
  font_color: string,
}

const ButtonSave: React.FC<Props> = ({ children, theme, onClick, icon, className, loading }) => {

  const icon_model: Record<IconKey, IconComponent> = {
    'copy': BoletoIcon,
    'share': ShareIcon,
    'share_white': ShareIconWhite,
    'download': DownloadIcon,
    'none': DownloadIcon
  }

  const IconComponent = icon_model[icon]

  const theme_model: Record<ThemeKey, ThemeValues> = {
    darkgreen: {
      border: "border-green-dark",
      bg: "bg-green-dark hover:bg-green-medium",
      font_color: "text-white-primary"
    },
    mediumgreen: {
      border: "border-green-medium",
      bg: "bg-green-medium",
      font_color: "text-white-primary"
    },
    lightgreen: {
      border: "border-green-disabled",
      bg: "bg-green-disabled",
      font_color: "text-white-primary"
    },
    white: {
      border: "border-green-dark",
      bg: "bg-white-default",
      font_color: "text-gray-dark"
    },
    blue: {
      border: "bg-blue-primary",
      bg: "bg-blue-primary",
      font_color: "text-white-primary"
    }
  }

  return (
    <button
      className={`
        px-[1.6rem]
        py-[0.6rem]
        rounded-[0.75rem]
        flex flex-row
        justify-center
        items-center
        border
        w-[100%]
        font-semibold
        font-[Kanit]
        ${theme_model[theme].border}
        ${theme_model[theme].font_color}
        ${theme_model[theme].bg}
        ${className}
     `}
      onClick={onClick}
    >
      {icon !== 'none' && !loading &&
        <IconComponent className="mr-1.5 w-[1rem] h-[1rem]" />
      }
      {loading ?
        <LoadingSpinner className="w-[1rem] h-[1rem]" /> :
        <p>{children}</p>
      }

    </button >
  );
}

export default ButtonSave;
